import { render, staticRenderFns } from "./TransferAssets.vue?vue&type=template&id=b510f378&scoped=true"
import script from "./TransferAssets.vue?vue&type=script&lang=js"
export * from "./TransferAssets.vue?vue&type=script&lang=js"
import style0 from "./TransferAssets.vue?vue&type=style&index=0&id=b510f378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510f378",
  null
  
)

export default component.exports